"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClosestNodes = void 0;
const Contact_1 = require("./Contact");
const SortedContactList_1 = require("./SortedContactList");
const getClosestNodes = (referenceId, contacts, opts) => {
    const list = new SortedContactList_1.SortedContactList({
        referenceId,
        allowToContainReferenceId: true,
        excludedNodeIds: opts?.excludedNodeIds,
        maxSize: opts?.maxCount
    });
    for (const contact of contacts) {
        list.addContact(new Contact_1.Contact(contact));
    }
    return list.getClosestContacts().map((n) => n.getPeerDescriptor());
};
exports.getClosestNodes = getClosestNodes;
//# sourceMappingURL=getClosestNodes.js.map